const Settings = require('./domain/settings'),
	adManager = require('./services/adManager'),
	breakpoints = require('./services/breakpoints'),
	lazyLoadManager = require('./services/lazyLoadManager'),
	messaging = require('./services/messaging'),
	sizeMappings = require('./services/sizeMappings'),
	slotManager = require('./services/slotManager'),
	refreshManager = require('./services/refreshManager');

function init(config) {
	return new Promise((resolve) => {
		performance.mark('advert - dfp - initialisation - start');

		const settings = new Settings(config);

		messaging.init();
		breakpoints.init(settings.breakpoints);
		sizeMappings.init(settings.sizeMapping);
		refreshManager.init(settings.refreshThreshold, settings.refreshDelay);
		adManager.init(settings).then(() => {
			lazyLoadManager.init(settings.lazyLoadThreshold);

			return slotManager.init(settings);
		}).then(() => {
			performance.mark('advert - dfp - initialisation - end');
			resolve();
		});
	});
}

module.exports = {
	init,
	'actions': {
		'loadSlot': slotManager.loadSlot,
		'getSlot': slotManager.getSlot,
		'getSlots': slotManager.getSlots,
		'getCurrentBreakpoint': breakpoints.getCurrentBreakpoint
	}
};
